import { useEffect, ReactNode } from "react";
import { NavLink } from "react-router-dom";
import { SidebarNav } from "./SidebarNav";
import { TopBar } from "./TopBar";
import { CommandPalette } from "./CommandPalette";
import { useNotificationStore } from "@/store/notificationStore";
import { useAuth } from "@/contexts/AuthContext";
import { NAV_GROUPS, ACCOUNT_NAV, ADMIN_NAV } from "@/shared/nav";
import { isAdminUser, canUser } from "@/shared/rbac";
import { useVertical } from "@/lib/useVertical";

function MobileNav() {
  const { user } = useAuth();
  const { id: vertical } = useVertical();
  const items = [
    ...NAV_GROUPS.flatMap((g) => g.items),
    ...ACCOUNT_NAV,
    ...(isAdminUser(user) ? ADMIN_NAV : []),
  ].filter((i) => (!i.perm || canUser(user, i.perm)) && !(i.excludeVerticals || []).includes(vertical));
  return (
    <div className="lg:hidden border-b bg-card overflow-x-auto">
      <div className="flex gap-1 px-3 py-2">
        {items.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            data-testid={`mnav-${item.to.replace("/", "")}`}
            className={({ isActive }) =>
              `whitespace-nowrap rounded-full px-3 py-1.5 text-xs font-medium transition-colors ${
                isActive ? "bg-forest-900 text-white" : "bg-muted text-muted-foreground"
              }`
            }
          >
            {item.label}
          </NavLink>
        ))}
      </div>
    </div>
  );
}

export function AppShell({ children }: { children: ReactNode }) {
  const fetchNotifs = useNotificationStore((s) => s.fetch);

  useEffect(() => {
    fetchNotifs();
    const t = setInterval(fetchNotifs, 60_000);
    return () => clearInterval(t);
  }, [fetchNotifs]);

  return (
    <div className="min-h-screen bg-background text-foreground flex">
      <SidebarNav />
      <div className="flex-1 min-w-0 flex flex-col">
        <TopBar />
        <MobileNav />
        <main className="flex-1">
          <div className="max-w-[1500px] mx-auto px-4 sm:px-6 lg:px-8 py-6 lg:py-8">{children}</div>
        </main>
      </div>
      <CommandPalette />
    </div>
  );
}

export default AppShell;
